
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/hooks/use-toast";

export const usePlanNavigation = () => {
  const { user, login, isLoading } = useAuth();
  const { toast } = useToast();

  // Safe navigation hook that doesn't throw if Router context is missing
  let navigate: ReturnType<typeof useNavigate> | null = null;
  try {
    navigate = useNavigate();
  } catch (error) {
    console.warn("Router context not available for usePlanNavigation");
    navigate = null;
  }

  const navigateToPlan = async (planType?: 'free' | 'basic' | 'pro' | 'premium') => {
    if (isLoading) return;

    if (!user) {
      // Store the intended plan for after login
      if (planType) {
        sessionStorage.setItem('intended_plan', planType);
      }
      
      toast({
        title: "Login necessário",
        description: "Faça login para acessar os planos e gerenciar sua assinatura.",
      });

      try {
        await login();
      } catch (error) {
        console.error("Error during login:", error);
      }
    } else {
      // User is already logged in, go directly to settings
      navigate?.('/configuracoes');
      
      if (planType && planType !== 'free') {
        const planNames = {
          basic: 'Básico',
          pro: 'Pro',
          premium: 'Premium'
        };
        toast({
          title: "Planos disponíveis",
          description: `Você pode assinar o plano ${planNames[planType]} na página de configurações.`,
        });
      }
    }
  };

  return { navigateToPlan };
};
